import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { FilterApi } from "../../filter/filter.api";
import { Establishments } from "./models/establishments.model";
import { Observable } from "rxjs";
import { EstablishmentsDto } from "./dto/establishments.dto";
import { EstablishmentExpectedProductsApi } from "./establishment-expected-products.api";
import { DateFilterDto } from "../inventory-snapshot/dto/inventory-snapshot.dto";
import { TrashedProducts } from "../trashed-products/models/trashed.products";
import { HttpUtils } from "../../../utils/http.utils";

@Injectable()
export class EstablishmentApi extends FilterApi<Establishments> {
    constructor(
        protected http: HttpClient
    ) {
        super("establishment", http);
    }

    public expectedProduct(establishmentId: number): EstablishmentExpectedProductsApi {
        return new EstablishmentExpectedProductsApi(this.http, establishmentId);
    }

    public findTrashedProductByEstablishmentId(id: number, dto: DateFilterDto): Observable<TrashedProducts[]> {
        const params = HttpUtils.transformQueryParams(dto);
        return this.get<TrashedProducts[]>(`${id}/trashed-product?${params}`);
    }

    public isNipAlreadyUsed(nip: string): Observable<boolean> {
        return this.get<boolean>(`nip/${nip}`);
    }

    public getById(id: number): Observable<Establishments> {
        return this.get<Establishments>(`${id}`);
    }

    public getAll(): Observable<Establishments[]> {
        return this.get<Establishments[]>("");
    }

    public create(dto: EstablishmentsDto): Observable<Establishments> {
        return this.post<Establishments>("", dto);
    }

    public update(id: number, dto: EstablishmentsDto): Observable<void> {
        return this.put<void>(`${id}`, dto);
    }

    public remove(id: number): Observable<void> {
        return this.delete<void>(`${id}`);
    }

    public printQrCode(): Observable<string> {
        return this.httpClient.get(this.url("print-qr"), { responseType: "text" });
    }

    public printQrCodeById(id: number): Observable<string> {
        return this.httpClient.get(this.url(`${id}/print-qr`), { responseType: "text" });
    }
}
